import React, { useEffect } from "react";
import "./HomeBanner.css";
import place1 from "../../Asset/place1.jpeg";
import place2 from "../../Asset/place2.jpeg";
import place3 from "../../Asset/place3.jpeg";
import { MoonIcon } from "@heroicons/react/24/solid";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import client1 from "../../Asset/client1.webp";
import client2 from "../../Asset/client2.webp";
import { PiMountainsFill } from "react-icons/pi";
import { MdOutlineFastfood } from "react-icons/md";
import { MdTravelExplore } from "react-icons/md";
import { TbDeviceGamepad } from "react-icons/tb";

const HomeBanner = () => {
  gsap.registerPlugin(ScrollTrigger);
  let t1 = gsap.timeline({ paused: true, reversed: true });

  useEffect(() => {
    t1.play();

    t1.to(".homeHeadingcontainer", {
      opacity: 1,
    });
    t1.to(".homeHeadingcontainer", {
      // opacity: 0,
      scrollTrigger: {
        trigger: ".homeHeadingcontainer",
        start: "top 45%",
        scrub: 2,
      },
    });
    t1.to(".meta", {
      top: "50%",
      left: "50%",
      opacity: 0,
      scrollTrigger: {
        trigger: ".homeHeadingcontainer",
        start: "top 45%",
        scrub: 2,
      },
    });
    t1.to(".fb", {
      top: "50%",
      left: "50%",
      rotate: 0,
      opacity: 0,
      scrollTrigger: {
        trigger: ".homeHeadingcontainer",
        start: "top 45%",
        scrub: 2,
      },
    });
    t1.to(".tiktok", {
      top: "50%",
      left: "50%",
      opacity: 0,
      scrollTrigger: {
        trigger: ".homeHeadingcontainer",
        start: "top 45%",
        scrub: 2,
      },
    });
    t1.to(".signal", {
      top: "50%",
      rotate: 0,
      left: "50%",
      opacity: 0,
      scrollTrigger: {
        trigger: ".homeHeadingcontainer",
        start: "top 45%",
        scrub: 2,
      },
    });
    t1.to(".moon", {
      rotate: 0,
      top: "50%",
      left: "50%",
      opacity: 0,
      scrollTrigger: {
        trigger: ".homeHeadingcontainer",
        start: "top 45%",
        scrub: 2,
      },
    });
    t1.to(".box", {
      opacity: 1,
      width: "120vw",
      height: "130vh",
      scrollTrigger: {
        trigger: ".headddd",
        start: "top 100% ",
        scrub: 1,
      },
    });
  }, []);

  return (
    <>
      <div className="HomeBanner">
        <div className="homeBannerContainer">
          <div className="homeHeadingcontainer">
            <div className="homeHeading1">
              <h1>A </h1>
              <img src={place1} alt="" />
              <h1>
                <span className="tiny">tiny</span>{" "}
                <span className="mountain">mountain</span>{" "}
              </h1>
            </div>
            <div className="homeHeading2">
              <h1> village </h1>
              <img src={place2} /> <h1>where it all</h1>
            </div>
            <div className="homeHeading3">
              <h1>began . . .</h1>
              <img src={place3} />
            </div>
          </div>

          <MdOutlineFastfood className="meta" />
          <PiMountainsFill className="fb" />
          <MdTravelExplore className="tiktok" />
          <TbDeviceGamepad className="signal" />
          <MoonIcon className="moon" />
        </div>
      </div>
      <div className="ourClient">
        <h1 className="headddd">
          Life is short and the world is wide. <br /> Better get started.
        </h1>
        {/* <div className="clientLogoContainer">
          <img src={client2} alt="" />
          <img src={client1} alt="" />
        </div> */}
      </div>
    </>
  );
};

export default HomeBanner;
